<div class="w300px">

    <h6 class="ft500 ft16 centertext">Permisos de administrador</h6>

    <label class="mgt10">Correo del administrador </label>
    <input type="text" [(ngModel)]="adminEmail" [ngModelOptions]="{standalone: true}" class="fw">


    <label class="mgt10">Tipo de privilegio:</label>
    <select [(ngModel)]="privilegio" class="fw">
        <option value="superadmin">superadmin</option>
        <option value="administrador">administrador</option>
        <option value="editor">editor</option>
    </select>

    <button (click)="makeAdmin(privilegio)" class="mgt10 darkButton fw">Continuar</button>

</div>

<!-- <div>Inserte el correo del instructor que desea añadir</div>
<form [formGroup]="instructorForm" class="center-align admin-actions" style="margin: 40px auto; max-width: 300px;">
    <input formControlName="email" type="email" placeholder="user email" id="instructor-email" required />
    <button (click)="" class="btn-small yellow darken-2 z-depth-0">Make Instructor</button>
</form> -->